export const REQUEST_CREATE_SIGNATURE = 'signature/REQUEST_CREATE_SIGNATURE';
export const REQUEST_GET_SIGNATURE_FILE =
  'signature/REQUEST_GET_SIGNATURE_FILE';
export const REQUEST_CREATE_PIN = 'signature/REQUEST_CREATE_PIN';
export const REQUEST_VALIDATE_PIN = 'signature/REQUEST_VALIDATE_PIN';
